module.exports = __webpack_public_path__ + "img/2148f4e.jpg";